import { CartAffiliate, SalesChannel } from '@/api/Cart/cart.interfaces';

export function isChannelMetaHotel(affiliate: CartAffiliate | null) {
    return affiliate && affiliate.SalesChannel === SalesChannel.Meta_hotel;
}

export function isChannelMetaFlight(affiliate: CartAffiliate | null) {
    return affiliate && affiliate.SalesChannel === SalesChannel.Meta_flight;
}
